module.exports = __webpack_public_path__ + "img/vb.801f538d.svg";